import makeValidationSchema from './StatusNotificationMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React, { useEffect } from 'react'
import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants
} from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import NaAciHwAttachedCCNAutoComField from 'src/components/na/autocomplete/codemaintenance/NaAciHwAttachedCCNAutoComField'
import { useFormContext, useWatch } from "react-hook-form";
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngSelectField,
      CngLookupAutocompleteField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const {
  filter: {EQUAL}
} = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  shipmentId:"",
  name: "",
  snType: "",
  shipmentControlNum: "",
  email: "",
  mobileNum: "",
  faxNum: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  manifestId
}) {
  const { setValue, getValues, reset } = useFormContext();
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  let manifestIden = getValues("shipmentId");
  console.log("manifestIDDDDD",manifestIden)

  useWatch("fileForUserId");
  useWatch("fileForUserLoginId")
  useWatch("fileForUserPartyId");
  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setValue("fileForUserId", fileForUserDetails.fileForUserId)
      setValue("fileForUserLoginId", fileForUserDetails.fileForUserLoginId)
      setValue("fileForUserPartyId", fileForUserDetails.fileForUserPartyId)
    }
  }, []);

	return (
    <Card>
      <CngSimpleCardHeader title={aciHighwayManifestTranslationText.statusNotificationTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.name}>
            <CngTextField
            required
              name="name"
              label={aciHighwayManifestTranslationText.name}
              disabled={disabled}
              onChange={(e) => {
                setValue("name", e.target.value.toUpperCase(), { shouldValidate: true })
              }}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.snType}>
            <CngCodeMasterAutocompleteField
            required
              name="snType"
              label={aciHighwayManifestTranslationText.snType}
              disabled={disabled}
              codeType='ACIHW_STATUS_NOTIFI_TYPE'
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.shipmentControlNum}>
             <CngLookupAutocompleteField
               name="shipmentControlNum"
               label={aciHighwayManifestTranslationText.shipmentControlNum}
               lookupProps={{
               filters: [{ field: 'manifestId', operator: EQUAL, value: manifestIden }],
               label: 'ccn',
               url:  AciHighwayCargoApiUrls.SN_CCN_SEARCH, 
               value: 'ccn'
             }}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.email}>
            <CngTextField
            required
              name="email"
              label={aciHighwayManifestTranslationText.email}
              disabled={disabled}
              onChange={(e) => {
                setValue("email", e.target.value.toUpperCase(), { shouldValidate: true })
              }}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.mobileNum}>
            <CngTextField
              name="mobileNum"
              label={aciHighwayManifestTranslationText.mobileNum}
              disabled={disabled}
              onChange={(e) => {
                setValue("mobileNum", e.target.value.toUpperCase(), { shouldValidate: true })
              }}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.faxNum}>
            <CngTextField
              name="faxNum"
              label={aciHighwayManifestTranslationText.faxNum}
              disabled={disabled}
              onChange={(e) => {
                setValue("faxNum", e.target.value.toUpperCase(), { shouldValidate: true })
              }}
            />
          </CngGridItem>
        </Grid>
      </CardContent>
    </Card>
	)
}

const StatusNotificationFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default StatusNotificationFormProperties
